import { Modal } from '@iziwork/design-system';
import { useEffect } from 'react';

import { ModalStates } from '~/contexts/ApplyFormContext/enums';
import RecaptchaContextProvider from '~/contexts/RecaptchaContext/RecaptchaContext';
import { useApplyFormContext, useToastContext, useTranslation } from '~/hooks';

export type ApplyFormModalContentProps = {
  onClose: () => void | Promise<void>;
};

export const ApplyFormModalContent = ({ onClose }: ApplyFormModalContentProps) => {
  const { t } = useTranslation();
  const { setToastError, closeToast } = useToastContext();

  const { State, states, setState, error, setError } = useApplyFormContext();

  useEffect(() => {
    if (error) {
      setToastError(t('toasts.application_error_body'), {
        heading: t('toasts.application_error_title'),
        onClose: () => setError(null),
      });
    } else {
      closeToast();
    }
  }, [error]);

  return (
    <RecaptchaContextProvider>
      <Modal.Dialog
        isOpened
        id={State.id}
        onClose={onClose}
        header={State.Header ? <State.Header /> : null}
        body={State.Body ? <State.Body setState={(state: ModalStates) => setState(states[state])} /> : null}
        footer={State.Footer ? <State.Footer onClose={onClose} /> : null}
      />
      <div />
    </RecaptchaContextProvider>
  );
};
